import React, { memo } from 'react';

import style from './style.module.css';

const getAvatarString = (name = '') => {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0][0];

  return `${parts[0][0]}${parts[parts.length - 1][0]}`;
};

const AvatarComponent = ({ name = '', size, color, backgroundColor }) => (
  <div className={`${style.host} ${style[size]}`} style={{ color, backgroundColor }}>
    {getAvatarString(name)}
  </div>
);

export const Avatar = memo(AvatarComponent);
